/* unplugin-vue-components disabled */import script from "./AlbumViewDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./AlbumViewDialog.vue?vue&type=script&setup=true&lang=js"

import "./AlbumViewDialog.vue?vue&type=style&index=0&id=37add5e6&lang=scss"

const __exports__ = script;

export default __exports__